import { IconButton, LuIcon } from "@overmap-ai/blocks"
import { getRouteApi, useNavigate } from "@tanstack/react-router"
import { memo, useCallback } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/create")

export const CreateProcedureInitiativeViewTopBar = memo(() => {
	const { redirect } = routeApi.useSearch()
	const navigate = useNavigate()

	const handleCancel = useCallback(() => {
		if (redirect) {
			void navigate({
				href: redirect,
				replace: true,
			})
		} else {
			void navigate({
				from: "/$organizationId/$projectId/initiatives/create",
				to: "/$organizationId/$projectId/initiatives",
				replace: true,
			})
		}
	}, [navigate, redirect])

	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<IconButton variant="ghost" accentColor="base" onClick={handleCancel}>
					<LuIcon icon={modelIconMapping.arrowLeft} />
				</IconButton>
			}
		/>
	)
})
CreateProcedureInitiativeViewTopBar.displayName = "CreateProcedureInitiativeViewTopBar"
